var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "preview-modal",
      on: {
        close: function($event) {
          _vm.$emit("close")
        }
      }
    },
    [
      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
        _c("h4", [_vm._v("Follow up Email Preview")])
      ]),
      _vm._v(" "),
      _c("div", { attrs: { slot: "body" }, slot: "body" }, [
        _c("div", { staticClass: "row mb-1" }, [
          _c("div", { staticClass: "col-6 pr-1" }, [
            _c("div", { staticClass: "select-wrap" }, [
              _c("label", [_vm._v("Email")]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.followUp.customer_email))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-6 pl-1" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mb-1" }, [
          _c("div", { staticClass: "col-6 pr-1" }, [
            _c("div", { staticClass: "select-wrap" }, [
              _c("label", [_vm._v("Subject")]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.followUp.subject))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-6 pl-1" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mb-2" }, [
          _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "select-wrap email-body-preview" }, [
              _c("label", [_vm._v("Email body")]),
              _vm._v(" "),
              _c("p", {
                directives: [
                  {
                    name: "dompurify-html",
                    rawName: "v-dompurify-html",
                    value: _vm.followUp.body,
                    expression: "followUp.body"
                  }
                ]
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col text-right" }, [
            _c("p", [_vm._v(_vm._s(_vm.followUp.date))])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [_c("p")])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a47dbeb8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a47dbeb8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/leads/followUps/PreviewEmail.vue
// module id = null
// module chunks = 